import { createContext } from 'react';

export interface NotificationPermissionContextValue {
  isNativeApp: boolean;
  hasPushNotificationsEnabled: boolean;
  devicesLoading: boolean;
  requestPushNotifications: () => void;
}

export const NotificationPermissionContext =
  createContext<NotificationPermissionContextValue | null>(null);
